// src/index.js ou src/main.jsx (conforme seu projeto)
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app.jsx";
import { AuthProvider } from "./app/Context/auth";
import "./report-actions.css";
import "./lista-cadastros.css";

// IMPORTAÇÕES DO TEMA
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { NOME_PLATAFORMA } from "./app/Config/branding";

const hostsLocais = ["localhost", "127.0.0.1", "::1"];
if (hostsLocais.includes(window.location.hostname)) {
  document.title = NOME_PLATAFORMA;
  document
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => link.setAttribute("href", "/favicon.ico"));
}

// Seleciona o root do HTML
const container = document.getElementById("root");
const root = createRoot(container);

// Renderização da aplicação com AuthProvider + ThemeProvider
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* aplica reset global e deixa visual mais limpo */}
      
      <AuthProvider>
        <App />
      </AuthProvider>

    </ThemeProvider>
  </React.StrictMode>
);
